import PropTypes from 'prop-types';
import styles from './FJModalItem.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import HotIcon from '../../../assets/svg/hot.svg?react';
import NewIcon from '../../../assets/svg/new.svg?react';
import FJTextWithEllipsisParent from '../FJTextWithEllipsis/FJTextWithEllipsisParent';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import FJImage from '../FJImage/FJImage';

const FJModalItem = props => {
    const { imgSrc, name, selected, onClick, isHot, isNew, isShowInBorder = true } = props;

    return (
        <div className={styles.container} onClick={onClick}>
            <FJHoverBoardGradation active={selected} borderRadius={10} isShowInBorder={isShowInBorder}>
                <FJImage imgSrc={imgSrc} boxClassName={styles.img_box} imgClassName={styles.img} />
            </FJHoverBoardGradation>

            {isHot && <HotIcon className={styles.hot} />}
            {isNew && <NewIcon className={styles.new} />}
            <FJTextWithEllipsisParent className={styles.name} text={FJLocalStore._(name)} />
        </div>
    );
};
FJModalItem.propTypes = {
    imgSrc: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    isHot: PropTypes.bool,
};
export default FJModalItem;
